<script>
export default {
  props: {
    applications: {
      type: Array,
      required: true,
    },
    active: {
      type: String,
      required: true,
    },
    status: {
      type: Number,
      required: true,
    },
    applicationListToggle: {
      type: Boolean,
      required: true,
    },
    // eslint-disable-next-line vue/require-prop-types
    type: {
      required: true,
    },
  },
  data() {
    return {}
  },
  beforeDestroy() {
    var doc = this.$refs.applinkmain
    if (doc !== undefined) doc.innerHTML = ''
  },
  methods: {
    setCurrentApplication(data) {
      this.$emit('click', data)
    },
  },
}
</script>
<template>
  <!-- $style.applicationsList, $style.close :- for cloasing form menu. -->

  <div
    ref="applinkmain"
    :class="
      applicationListToggle
        ? [$style.applicationsList, $style.open]
        : [$style.applicationsList]
    "
  >
    <FormBaseApplicationLinkRoutes
      :applications="applications"
      :active="active"
      :status="status"
      :type="type"
      @click="setCurrentApplication"
    />
  </div>
</template>

<style lang="scss" module>
@import '@design';

.applicationsList {
  z-index: 4;
  width: 40%;
  max-width: 300px;
  border-right: 2px solid #f8f9f9;
}

@media (max-width: 991px) {
  .applicationsList {
    width: 50%;
  }
}

@media (max-width: 767px) {
  .applicationsList {
    position: absolute;
    top: 0;
    right: -110%;
    display: block;
    width: 100%;
    max-width: 100% !important;
    height: 100%;
    background: #fff;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    transition: all ease-in-out 0.3s;

    &.open {
      right: 0 !important;
    }
  }
}
</style>
